export default {
  title: "Settings",
  subtitle: "Manage application settings and configuration",
  
  sections: {
    general: "General Settings",
    appearance: "Appearance",
    notifications: "Notifications",
    security: "Security",
    integrations: "Integrations",
    advanced: "Advanced"
  },
  
  fields: {
    siteName: "Site Name",
    siteDescription: "Site Description",
    language: "Default Language",
    timezone: "Timezone",
    currency: "Default Currency",
    theme: "Theme",
    emailNotifications: "Email Notifications",
    smsNotifications: "SMS Notifications",
    twoFactorAuth: "Two-Factor Authentication",
    sessionTimeout: "Session Timeout",
    maxLoginAttempts: "Max Login Attempts",
    passwordPolicy: "Password Policy",
    backupFrequency: "Backup Frequency",
    maintenanceMode: "Maintenance Mode"
  },
  
  placeholders: {
    siteName: "Enter site name",
    siteDescription: "Enter site description",
    sessionTimeout: "Enter timeout in minutes"
  },
  
  messages: {
    updateSuccess: "Settings updated successfully",
    updateError: "Failed to update settings",
    resetSuccess: "Settings reset to default",
    resetError: "Failed to reset settings",
    resetConfirm: "Are you sure you want to reset all settings to default?",
    loadingSettings: "Loading settings...",
    fetchError: "Failed to fetch settings"
  },
  
  validation: {
    siteNameRequired: "Site name is required",
    sessionTimeoutMin: "Session timeout must be at least 5 minutes",
    sessionTimeoutMax: "Session timeout must not exceed 1440 minutes"
  },
  
  actions: {
    save: "Save Settings",
    reset: "Reset to Default",
    export: "Export Settings",
    import: "Import Settings"
  },
  
  themes: {
    light: "Light",
    dark: "Dark",
    auto: "Auto"
  },
  
  frequencies: {
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly"
  },
  
  breadcrumbs: {
    settings: "Settings",
    general: "General",
    appearance: "Appearance",
    notifications: "Notifications",
    security: "Security"
  }
};
